<template>
  <div class="main">
    <div class="lists">
      <ul>
        <li
          v-for="(item, index) in typeList"
          :key="item.id"
          :class="{ current: item.id == currentid }"
          @click="setList(item.id)"
        >
          {{ item.name }}
          <span class="operate">
            <a-icon
              class="dynamic-ok-button"
              type="edit"
              @click="typeEdit(index)"
            />
            <a-icon
              class="dynamic-delete-button"
              type="delete"
              @click="deleteType(item.id)"
            />
          </span>
        </li>
        <li class="type" v-if="busy">
          <a-input placeholder="请填写服务名称" v-model="typeParam.name" />
          <a-icon
            class="dynamic-ok-button"
            type="check-circle-o"
            @click="saveType"
          />
          <a-icon
            class="dynamic-delete-button"
            type="minus-circle-o"
            @click="addType"
          />
        </li>
        <li class="add" @click="addType" v-else>
          <a-icon type="plus" />
        </li>
      </ul>
    </div>
    <div class="item-lists">
      <a-card
        hoverable
        class="item"
        v-for="(item, index) in itemList"
        :key="item.id"
      >
        <a-icon
          type="close-circle"
          class="delete-icon"
          @click="deleteItem(index)"
        />
        <div @click="itemEdit(index)">
          <a-avatar
            style="backgroundColor:#87d068"
            :size="48"
            icon="picture"
            v-if="item.icon == ''"
          />
          <a-avatar :size="48" :src="item.icon" v-else />
        </div>
        <div class="name">{{ item.title }}</div>
      </a-card>
      <a-card hoverable class="item add" @click="add()">
        <a-tooltip>
          <template slot="title">增加服务</template>
          <a-icon type="plus" style="font-size:18px;" />
        </a-tooltip>
      </a-card>
    </div>
    <a-modal
      title="编辑类别名称"
      :visible="TypeVisible"
      @ok="typeEditSave"
      @cancel="typeEditCancel"
    >
      <p>
        <a-input v-model="typeName" />
      </p>
    </a-modal>
    <a-modal title="新增服务" v-model="visible" @ok="save()">
      <a-form-item label="服务图标">
        <a-upload-dragger
          accept="image/*"
          name="file"
          :multiple="true"
          :headers="headers"
          :beforeUpload="beforeUpload"
          style="display:none;"
        >
          <div ref="imgupload">
            <a-icon type="inbox" />
          </div>
        </a-upload-dragger>
        <a-avatar
          class="change"
          :size="72"
          icon="picture"
          :src="param.icon"
          @click="uploadImg"
        />
      </a-form-item>
      <a-form-item label="服务名称">
        <a-input placeholder="请填写服务名称" v-model="param.title" />
      </a-form-item>
      <a-form-item label="链接地址">
        <a-input placeholder="请填写服务名称" v-model="param.linkurl" />
      </a-form-item>
      <!-- <a-avatar style="backgroundColor:#87d068" :size="48" icon="user" /> -->
    </a-modal>
    <!-- <a-modal title="编辑服务事项" :visible="itemVisible" @ok="saveItemEdit" @cancel="cancelItemEdit">
      <p>{{ModalText}}</p>
    </a-modal>-->
    <!-- <a-card title="设置">
      <a-card-grid class="item" v-for="i in num" :key="i">
        <a-avatar style="backgroundColor:#87d068" :size="40" icon="user" />
        <span class="name">服务事项</span>
      </a-card-grid>
      <a-card-grid class="item add" @click="add">
        <a-tooltip>
          <template slot="title">增加服务</template>
          <a-icon type="plus" />
        </a-tooltip>
      </a-card-grid>
    </a-card>-->
  </div>
</template>

<script>
export default {
  data() {
    return {
      typeName: '',
      currentid: 0,
      busy: false,
      num: 8,
      itemVisible: false,
      TypeVisible: false,
      visible: false,
      headers: {
        Authorization: window.localStorage.getItem('token')
      },
      imgdata: {
        blob_num: 1,
        total_blob_num: 1,
        file_name: '123.jpg'
      },
      param: {
        typeid: 1,
        icon: '',
        title: '',
        linkurl: '',
        id: ''
      },
      typeParam: {
        name: ''
      },
      typeList: [],
      itemListParam: {
        limit: 100,
        typeid: 0
      },
      itemList: [],
      editItemId: 0
    };
  },
  components: {},
  created() {
    this.getTypeList();
  },
  methods: {
    // saveItemEdit(){

    // },
    // cancelItemEdit(){

    // },
    deleteItem(index) {
      let that = this;
      this.$confirm({
        title: '删除确认',
        content: '确定删除该服务吗？删除后将不可恢复。g',
        onOk() {
          that.$http
            .post('/api/app/servedel', { ids: that.itemList[index].id })
            .then(res => {
              if (res.data.state == 200) {
                that.$message.success('操作成功');
                that.getItemList();
              } else {
                that.$message.warn('删除失败，请和管理员联系');
              }
            });
        },
        onCancel() {}
      });
    },
    itemEdit(index) {
      // this.editItemId = itemList[index].id;
      this.visible = true;
      this.param = this.itemList[index];
    },
    typeEdit(i) {
      this.currentid = this.typeList[i].id;
      this.typeName = this.typeList[i].name;
      this.TypeVisible = true;
    },
    typeEditSave() {
      let param = { id: this.currentid, name: this.typeName };
      this.$http.post('/api/app/servetypeupdate', param).then(res => {
        if (res.data.state == 200) {
          this.busy = false;
          this.getTypeList();
          this.$message.success('保存成功');
        }
      });
    },
    typeEditCancel() {
      this.TypeVisible = false;
    },
    deleteType(id) {
      let that = this;
      this.$confirm({
        title: '确定删除该类别吗？',
        content: '删除类别的同时将删除该类别下的所有服务',
        onOk() {
          that.$http.post('/api/app/servetypedel', { ids: id }).then(res => {
            if (res.data.state == 200) {
              that.$message.success('操作成功');
              that.getTypeList();
            } else {
              that.$message.warn('删除失败，请和管理员联系');
            }
          });
        },
        onCancel() {}
      });
    },
    setList(id) {
      this.currentid = id;
      this.getItemList();
    },
    getItemList() {
      this.itemListParam.typeid = this.currentid;
      this.itemList = [];
      this.$http.post('/api/app/servelist', this.itemListParam).then(res => {
        this.itemList = res.data.data;
        // console.log(res.data);
      });
    },
    getTypeList() {
      this.$http.get('/api/app/servetypelist').then(res => {
        this.typeList = res.data.data;
        if (this.typeList.length == 0) {
          this.$message.warn('暂无类别，请先添加分类');
        }
        this.currentid = this.typeList[0].id;
        this.getItemList();
      });
    },
    saveType() {
      this.$http.post('/api/app/servetypeupdate', this.typeParam).then(res => {
        if (res.data.state == 200) {
          this.busy = false;
          tis.getTypeList();
          this.$message.success('操作成功');
        }
      });
      // console.log(this.typeParam.typeName);
    },
    addType() {
      this.typeParam.name = '';
      this.busy = !this.busy;
    },
    add() {
      this.param = {
        icon: '',
        title: '',
        linkurl: '',
        id: ''
      };
      this.visible = true;
    },
    save() {
      this.param.typeid = this.currentid;
      this.$http.post('/api/app/serveupdate', this.param).then(res => {
        if (res.data.state == 200) {
          this.visible = false;
          this.$message.success('操作成功');
          this.getItemList();
        } else {
          this.$message.success('操作失败，请和管理员联系');
        }
      });
    },
    uploadImg() {
      this.$refs.imgupload.click();
    },
    async beforeUpload(file) {
      let res = await this.$http.post(
        'https://openapi.ycrmt.cn/aliyun/index/Imgesupload'
      );
      let data = res.data.data;
      let client = new this.$OSS({
        region: data.config.region,
        accessKeyId: data.result.Credentials.AccessKeyId,
        accessKeySecret: data.result.Credentials.AccessKeySecret,
        stsToken: data.result.Credentials.SecurityToken,
        bucket: data.config.bucket
      });
      let options = {
        callback: data.callback
      };
      options.callback.customValue.filename = file.name.substring(
        0,
        file.name.lastIndexOf('.')
      ); //原文件名称
      let date = new Date();
      let year = this.$moment().format('YYYY');
      let month = this.$moment().format('MM');
      let fileExtension = file.name.substring(file.name.lastIndexOf('.') + 1);
      let result = await client.put(
        data.path +
          year +
          '/' +
          month +
          '/' +
          this.$md5(date) +
          '.' +
          fileExtension,
        file,
        options
      );
      if (result.data.errno === 0) {
        this.$message.success('文件上传成功');
        this.param.icon = result.data.data;
      } else {
        this.$$message.error('文件上传失败');
      }
    }
  }
};
</script>
<style scoped>
.main {
  position: absolute;
  top: 60px;
  left: 20px;
  right: 20px;
  bottom: 20px;
  overflow-y: auto;
  padding: 20px;
  background-color: #fff;
}
.lists {
  position: absolute;
}
.lists ul {
  width: 200px;
  border: 1px solid #e8e8e8;
  border-radius: 3px;
}
.lists li {
  border-top: 1px solid #e8e8e8;
  margin-top: -1px;
  padding-left: 20px;
  width: 200px;
  height: 50px;
  line-height: 50px;
  cursor: pointer;
}
.lists li.current {
  background-color: #e6f7ff;
}
.lists li.type {
  padding-left: 5px;
}
.lists li.type input {
  width: 70%;
}
.lists li.add {
  padding-left: 0;
  font-size: 18px;
  text-align: center;
  cursor: pointer;
}
.lists .operate {
  position: absolute;
  right: 5px;
  display: none;
}
.lists li:hover .operate {
  display: inline-block;
}
.item-lists {
  position: absolute;
  left: 240px;
}
.item-lists .delete-icon {
  font-size: 18px;
  color: #999;
  display: none;
  position: absolute;
  right: 5px;
  top: 5px;
}
.item-lists .item:hover .delete-icon {
  display: inline;
}
.item-lists .item {
  width: 120px;
  height: 120px;
  margin: 0 10px 10px 0;
  text-align: center;
  padding-top: 20px;
  float: left;
}
.item-lists .add {
  padding: 0;
  line-height: 120px;
}
.item-lists .name {
  margin-top: 20px;
}
.change {
  /* background-color:#87d068; */
  cursor: pointer;
}
.dynamic-delete-button,
.dynamic-ok-button {
  left: 5px;
  cursor: pointer;
  position: relative;
  font-size: 18px;
  color: #999;
  transition: all 0.3s;
  margin-right: 5px;
}
.dynamic-ok-button:hover {
  color: #52c41a;
}
.dynamic-ok-button[disabled] {
  cursor: not-allowed;
  opacity: 0.5;
}
.dynamic-delete-button:hover {
  color: #777;
}
.dynamic-delete-button[disabled] {
  cursor: not-allowed;
  opacity: 0.5;
}
</style>
